import { render, staticRenderFns } from "./shopMesg.vue?vue&type=template&id=63f2cce3&scoped=true"
import script from "./shopMesg.vue?vue&type=script&lang=js"
export * from "./shopMesg.vue?vue&type=script&lang=js"
import style0 from "./shopMesg.vue?vue&type=style&index=0&id=63f2cce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2cce3",
  null
  
)

export default component.exports